import { OrderDetails } from '@nemuru-eng/js-api-client';

import { OrderAction } from '../../../../../types/OrderAction';
import { OrderActionType } from '../../../../../types/OrderActionType';
import { transformItemToOrderLineInAction } from '../../transformItemToOrderLineInAction';

export function getOrderCreationAction(orderDetails: OrderDetails): OrderAction {
  const currency = orderDetails.currency;
  return {
    id: orderDetails.order.id,
    type: OrderActionType.order,
    status: orderDetails.order.status,
    createdAt: orderDetails.createdAt,
    updatedAt: orderDetails.updatedAt,
    amount: { value: orderDetails.totalOrderAmount, currency },
    orderLines: orderDetails.order.items.map((item) => transformItemToOrderLineInAction(item, currency)),
  };
}
